<template>
  <Navbar />
  <Header :title="$t('_title_overview')" v-if="data.length != 0">
   
      <h2>{{ $t('overview_subtitle') }}</h2>
      <ul>
        <template v-if="!en">
          <li>資料範圍：{{ dataYear }}學年度  （ <font-awesome-icon :icon="['fas', 'right-long']" /><router-link to="/overview"> 前往歷年度</router-link>）</li>
          <li>畢業流向資料：{{ data.section_four_chart.dataInfo }}</li>
          <li>研究所包含碩士、博士及在職專班</li>
          <li>資料來源：本校註冊組、大專校院校務資訊公開平臺</li>
        </template>
        <template v-else>
          <li>Data Year: {{ data.dataYear+1911 }} </li>
          <!-- <li>Go to <font-awesome-icon :icon="['fas', 'right-long']" /><router-link to="/overview">Overview History</router-link></li> -->
          <li>Alumni Career Development:  {{ data.section_four_chart.dataInfoEn }}</li>
        </template>
      </ul>
      <p class="intro-note">{{ $t('overview_infoNote') }}</p>
  </Header>
  
  <Header :title="title" v-else>
    <Loader />
  </Header>

  <Totop />
  <div id="section-tab" class="section-tab">
    <ul>
        <li id="toStudent" class="student"><a href="#section_1">{{ $t('_cate_studnet') }}</a></li>
        <li id="toTeacher" class="teacher"><a href="#section_6">{{ $t('_cate_teacher') }}</a></li>
        <li v-if="dataYear <= lastestYear" id="toResearch" class="research"><a href="#section_9">{{ $t('_cate_research') }}</a></li>
        <li id="toOther" class="other"><a href="#section_10">{{ $t('_cate_other') }}</a></li>
    </ul>
  </div>

  <OverviewComp v-if="data.length != 0" :data="data" :datayear="dataYear" :lastestyear="lastestYear"  :en="en"/>
  <section class="section-container" v-else>
    <Loader />
  </section>

  <Footer />
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import OverviewComp from "@/components/OverviewComp.vue";
import Loader from "@/components/Loader.vue";
import Totop from "@/components/Totop.vue";

export default {
  name: "App",
  components: { Navbar, Header, Footer, OverviewComp, Loader, Totop },

  data() {
    return {
      title: "政大概覽",
      dataYear:'',
      lastestYear: "",
      data: [],
      en: false
    };
  },

  watch: {
    '$i18n.locale': function(newValue){
      if(newValue == 'en') this.en = true;
      else this.en = false;
    }
  },

  mounted() {
    // if(this.$i18n.locale != "zh"){
    //   let lang = this.$i18n.locale;
    //   this.$router.push({
    //     query: { lang } 
    //   });
    // }
    if(this.$i18n.locale == 'en') this.en = true;
    else this.en = false;

    fetch("data/data_years.json", {cache: "reload"})
      .then((respond) => respond.json())
      .then((data) => {
          this.dataYear = data.thisYear;
          this.lastestYear = data.completedata;

          fetch("data/data_"+this.dataYear+".json")
            .then((respond) => respond.json())
            .then((data) => {
              setTimeout(() => {
                this.data = data;
              }, 300);
                
            })
            .catch((err) => console.log(err.message));
      })
    .catch((err) => console.log(err.message));
  },

};
</script>

<style src="@/assets/css/overviewHeader.css" scoped></style>

<style scoped>

.intro a {
  color: var(--black);
  text-decoration: none;
}

.intro a:hover {
  color: var(--blue);
}
</style>